import {
	Avatar,
	Button,
	Card,
	CardActions,
	CardContent,
	CardHeader,
	FormControl,
	Stack,
	TextField,
} from '@mui/material';
import { Database } from '@phosphor-icons/react/dist/ssr/Database';
import { useFormik } from 'formik';
import { FC } from 'react';
import * as Yup from 'yup';

import { DashboardContentLayout } from '~ui-components/components/atoms/dashboard-content-layout';

export const DatasetDetailsSchema = Yup.object({
	name: Yup.string().required('Required'),
	description: Yup.string(),
	attribution: Yup.string(),
});

export type DatasetDetailsFormValues = Yup.InferType<
	typeof DatasetDetailsSchema
>;

export type DatasetDetailsProps = {
	form: ReturnType<typeof useFormik<DatasetDetailsFormValues>>;
};

export const DatasetDetails: FC<DatasetDetailsProps> = ({ form }) => {
	return (
		<DashboardContentLayout pageTitle="Settings">
			<Card component="form" onSubmit={form.handleSubmit}>
				<CardHeader
					avatar={
						<Avatar>
							<Database fontSize="var(--Icon-fontSize)" />
						</Avatar>
					}
					title="Details"
				/>
				<CardContent>
					<Stack spacing={3}>
						<FormControl>
							<TextField
								label="Name"
								{...form.getFieldProps('name')}
								error={!!form.errors.name}
								helperText={form.errors.name}
							/>
						</FormControl>
						<FormControl fullWidth>
							<TextField
								label="Description"
								minRows={3}
								multiline
								{...form.getFieldProps('description')}
								error={!!form.errors.description}
								helperText={form.errors.description}
							/>
						</FormControl>
						<FormControl fullWidth>
							<TextField
								label="Metadata/Attribution"
								minRows={3}
								multiline
								{...form.getFieldProps('attribution')}
								error={!!form.errors.attribution}
								helperText={form.errors.attribution}
							/>
						</FormControl>
					</Stack>
				</CardContent>
				<CardActions sx={{ justifyContent: 'flex-end', alignItems: 'center' }}>
					<Button color="inherit">Cancel</Button>
					<Button
						variant="contained"
						type="submit"
						disabled={form.isSubmitting || !form.isValid}
					>
						Save changes
					</Button>
				</CardActions>
			</Card>
		</DashboardContentLayout>
	);
};
